
// Collection of image URLs for placeholder art
export const artworkImages = [
  // Paintings
  "https://images.unsplash.com/photo-1579783902614-a3fb3927b6a5?auto=format&fit=crop&w=800&q=80", // Abstract
  "https://images.unsplash.com/photo-1549887534-1541e9326642?auto=format&fit=crop&w=800&q=80", // Portrait
  "https://images.unsplash.com/photo-1578301978693-85fa9c0320b9?auto=format&fit=crop&w=800&q=80", // Urban
  "https://images.unsplash.com/photo-1579783901586-d88db74b4fe4?auto=format&fit=crop&w=800&q=80", // Landscape
  "https://images.unsplash.com/photo-1501472312651-726afe119ff1?auto=format&fit=crop&w=800&q=80", // Art gallery
  "https://images.unsplash.com/photo-1560421683-6856ea585c78?auto=format&fit=crop&w=800&q=80", // Bold abstract
  "https://images.unsplash.com/photo-1578926375605-eaf7559b1458?auto=format&fit=crop&w=800&q=80", // Texture
  "https://images.unsplash.com/photo-1510314066419-6a90c56cb51a?auto=format&fit=crop&w=800&q=80", // Minimal
  "https://images.unsplash.com/photo-1515405295579-ba7b45403062?auto=format&fit=crop&w=800&q=80", // Colorful
  "https://images.unsplash.com/photo-1605721911519-3dfeb3be25e7?auto=format&fit=crop&w=800&q=80", // Blended colors
  
  // Sculptures
  "https://images.unsplash.com/photo-1563089145-599997674d42?auto=format&fit=crop&w=800&q=80", // Modern
  "https://images.unsplash.com/photo-1568219357666-6c045c14c966?auto=format&fit=crop&w=800&q=80", // Torso
  "https://images.unsplash.com/photo-1489939078242-74cc81f32279?auto=format&fit=crop&w=800&q=80", // Classic
  "https://images.unsplash.com/photo-1561839561-b13bcfe95249?auto=format&fit=crop&w=800&q=80", // Abstract sculpture
  "https://images.unsplash.com/photo-1543946207-39bd91e70ca7?auto=format&fit=crop&w=800&q=80", // Head sculpture

  // Digital Art
  "https://images.unsplash.com/photo-1518640467707-6811f4a6ab73?auto=format&fit=crop&w=800&q=80", // Surreal
  "https://images.unsplash.com/photo-1508780709619-79562169bc64?auto=format&fit=crop&w=800&q=80", // Digital manipulation
  "https://images.unsplash.com/photo-1600359726755-1fe52ba7deff?auto=format&fit=crop&w=800&q=80", // Tech art
  "https://images.unsplash.com/photo-1576495199011-eb94736d05d6?auto=format&fit=crop&w=800&q=80", // Colorful design
  "https://images.unsplash.com/photo-1551913290-06edfc98e70e?auto=format&fit=crop&w=800&q=80", // Generative art

  // Photography
  "https://images.unsplash.com/photo-1452421822248-d4c2b47f0c81?auto=format&fit=crop&w=800&q=80", // Street
  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?auto=format&fit=crop&w=800&q=80", // Portrait 
  "https://images.unsplash.com/photo-1519681393784-d120267933ba?auto=format&fit=crop&w=800&q=80", // Landscape
  "https://images.unsplash.com/photo-1561037404-61cd46aa615b?auto=format&fit=crop&w=800&q=80", // Architecture
  "https://images.unsplash.com/photo-1503023345310-bd7c1de61c7d?auto=format&fit=crop&w=800&q=80", // Nature

  // Mixed Media
  "https://images.unsplash.com/photo-1525909002-1b05e0c869d8?auto=format&fit=crop&w=800&q=80", // Collage
  "https://images.unsplash.com/photo-1552672205-c3d0e0a30010?auto=format&fit=crop&w=800&q=80", // Mixed texture
  "https://images.unsplash.com/photo-1513542789411-b6a5d4f31634?auto=format&fit=crop&w=800&q=80", // Books as art
  "https://images.unsplash.com/photo-1533158326339-7f3cf2404354?auto=format&fit=crop&w=800&q=80", // Installation
  "https://images.unsplash.com/photo-1603344204980-4edb0ea63148?auto=format&fit=crop&w=800&q=80", // Mixed materials

  // Drawings
  "https://images.unsplash.com/photo-1602006655431-2ddc01548d95?auto=format&fit=crop&w=800&q=80", // Line art
  "https://images.unsplash.com/photo-1630684793872-a0b3e76119a1?auto=format&fit=crop&w=800&q=80", // Charcoal
  "https://images.unsplash.com/photo-1615184697985-c9bde1b07da7?auto=format&fit=crop&w=800&q=80", // Colorful drawing
  "https://images.unsplash.com/photo-1572994384812-8acb45186d6e?auto=format&fit=crop&w=800&q=80", // Pencil
  "https://images.unsplash.com/photo-1598867402948-c=bf4db934d2b?auto=format&fit=crop&w=800&q=80", // Detailed sketch

  // Printmaking
  "https://images.unsplash.com/photo-1576377388026-05847acb6a8f?auto=format&fit=crop&w=800&q=80", // Screen print
  "https://images.unsplash.com/photo-1619465918803-865f1c9d67ac?auto=format&fit=crop&w=800&q=80", // Woodblock
  "https://images.unsplash.com/photo-1629803334999-3c1bb454384a?auto=format&fit=crop&w=800&q=80", // Letterpress
  "https://images.unsplash.com/photo-1604947051230-5b6c200e7d98?auto=format&fit=crop&w=800&q=80", // Patterned print
  "https://images.unsplash.com/photo-1569303787589-b9d21e0abd9b?auto=format&fit=crop&w=800&q=80", // Linocut

  // Textile
  "https://images.unsplash.com/photo-1544365558-35aa4afcf11f?auto=format&fit=crop&w=800&q=80", // Woven
  "https://images.unsplash.com/photo-1594753982165-e891f1d38bc8?auto=format&fit=crop&w=800&q=80", // Embroidery
  "https://images.unsplash.com/photo-1584811644165-33078db1e9d4?auto=format&fit=crop&w=800&q=80", // Fiber art
  "https://images.unsplash.com/photo-1600187145639-c60293080310?auto=format&fit=crop&w=800&q=80", // Hanging textile
  "https://images.unsplash.com/photo-1584942368608-0a679b89d667?auto=format&fit=crop&w=800&q=80", // Quilting

  // Additional modern and contemporary art
  "https://images.unsplash.com/photo-1547891654-e66ed7ebb968?auto=format&fit=crop&w=800&q=80", // Abstract shapes
  "https://images.unsplash.com/photo-1549490349-8643362247b5?auto=format&fit=crop&w=800&q=80", // Bold geometric
  "https://images.unsplash.com/photo-1505416795181-0296f93efb1a?auto=format&fit=crop&w=800&q=80", // Dynamic 
  "https://images.unsplash.com/photo-1579541891629-e84f2b332f91?auto=format&fit=crop&w=800&q=80", // Contemporary
  "https://images.unsplash.com/photo-1536924430914-91f9e2041b83?auto=format&fit=crop&w=800&q=80"  // Expressive
];

// Get a random image from the collection
export const getRandomArtworkImage = () => {
  return artworkImages[Math.floor(Math.random() * artworkImages.length)];
};

// Get a specific image by index, with fallback
export const getArtworkImage = (index: number) => {
  return artworkImages[index % artworkImages.length];
};

// This generates a set of unique images based on a seed value
export const getUniqueArtworkImages = (count: number, seed = 0) => {
  const result: string[] = [];
  for (let i = 0; i < count; i++) {
    const index = (seed + i) % artworkImages.length;
    result.push(artworkImages[index]);
  }
  return result;
};

// Artist profile images
export const artistImages = [
  "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=200&q=80",
  "https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=200&q=80",
  "https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=200&q=80",
  "https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?auto=format&fit=crop&w=200&q=80",
  "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=200&q=80",
  "https://images.unsplash.com/photo-1519345182560-3f2917c472ef?auto=format&fit=crop&w=200&q=80",
  "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=200&q=80",
  "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=200&q=80",
  "https://images.unsplash.com/photo-1552058544-f2b08422138a?auto=format&fit=crop&w=200&q=80",
  "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=200&q=80"
];

// Get a random artist image
export const getRandomArtistImage = () => {
  return artistImages[Math.floor(Math.random() * artistImages.length)];
};

// Get a specific artist image by index, with fallback
export const getArtistImage = (index: number) => {
  return artistImages[index % artistImages.length];
};
